import React from 'react'
import styles from './TRouteInfoModal.scss'
import { ConfirmationDialog } from 'common/styleguide/ConfirmationDialog'
import fetchJSON from 'lib/fetchJSON'
import { CircleSpinner } from 'common/spinners'
import p from 'prop-types'

export const TROUTE_INFO_MODAL = 'TROUTE_INFO_MODAL'

export class TRouteInfoModal extends React.PureComponent {
  static propTypes = {
    troute: p.object.isRequired, // Trip|Route
    objectType: p.string.isRequired, // 'trip'|'route\
    objectId: p.number.isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      trouteInfo: null
    }
  }

  componentDidMount () {
    const { objectType, objectId } = this.props
    fetchJSON(`/${objectType}s/${objectId}/admin_info.json`)
      .then(r => this.setState({ trouteInfo: r, loading: false }))
      .catch(r => this.setState({ loading: false }))
  }

  render () {
    const { loading, trouteInfo } = this.state
    const { troute, objectType, onRequestClose } = this.props

    return (
      <ConfirmationDialog
        primary
        title={`Info for ${troute.name}`}
        maxWidth='600px'
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={onRequestClose}
        confirmText='Dismiss'>
        {loading || !trouteInfo
          ? <CircleSpinner centered size={30} />
          : <Info info={trouteInfo} objectType={objectType} />}
      </ConfirmationDialog>
    )
  }
}

const Info = ({ info, objectType }) => {
  const trouteInfo = info[objectType]

  return <div>
    <Row label='MRP planned?' value={trouteInfo.mrp_planned ? 'Yes' : 'No'} />
  </div>
}

const Row = ({ label, value }) => <dl className={styles.infoRow}>
  <dt>{label}</dt>
  <dd>{value}</dd>
</dl>
